import { IAddress } from '@core/interfaces/address/address.interface';
import { CountryCode } from '@interticket/core';

export const ADDRESS_MOCK: IAddress = {
  addressGuid: 'f1fe8c3a-5950-4572-9fdc-bc37c72c57fc',
  type: 1,
  state: CountryCode.HU,
  country: CountryCode.HU,
  county: 'Pest',
  zipCode: '1139',
  postalCode: '1139',
  city: 'Budapest',
  district: '13',
  street: 'Váci út',
  houseNumber: '99',
  building: 'Balance',
  stairway: '',
  floor: '6',
  door: '1',
  comment: '',
  longitude: 19.0687928,
  latitude: 47.5403445,
  timezone: 1,
};
